import RiskManagementKeycloak from "../libraries/RiskManagementKeycloak";

class CISFeatureService {
  static GetFeatureByFeatureId = (featureId) => {
    return RiskManagementKeycloak.RefreshToken().then(() => {
      return fetch(process.env.REACT_APP_CorporateIdentityService_URL + "/feature/" + featureId, {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: RiskManagementKeycloak.Access_Token,
        },
      }).then((response) => {
        if (response.status === 200) {
          return response.json();
        } else {
          return null;
        }
      });
    });
  };
}
export default CISFeatureService;
